export const FEEDER_TYPES = {
  FUTURES: 'Futures',
  LIVE_PRICES: 'Live Prices',
  FUNDAMENTAL_DATA: 'Fundamental Data',
  FORWARD_CURVE: 'Forward Curve',
  ICIS_LONG_TERM_MODEL: 'ICIS Long-Term Model',
  SPOT: 'Spot',
} as const;
export type FeederMenuType = (typeof FEEDER_TYPES)[keyof typeof FEEDER_TYPES];
